import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetCommissionBalanceResponse {
  status?: boolean;
  message?: string;
  data?: {
    commissionId?: number;
    commissionNumber?: number;
    ledgerBalance?: number;
    availableBalance?: number;
    withdrawableBalance?: number;
  };
  errors?: IApiResponseError;
}

const initialState: IApiState<IGetCommissionBalanceResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getCommissionBalanceAsync = createAsyncThunk(
  'commissionBalance/get',
  async (commissionNumber: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/commission/transactions/${commissionNumber}/balance`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IGetCommissionBalanceResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const commissionBalanceFetch = createSlice({
  name: 'commissionBalance/fetch',
  initialState,
  reducers: {
    resetCommissionBalance: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommissionBalanceAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getCommissionBalanceAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetCommissionBalanceResponse;
      })
      .addCase(getCommissionBalanceAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetCommissionBalanceResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetCommissionBalance } = commissionBalanceFetch.actions;
export default commissionBalanceFetch.reducer;
